import React from 'react';
import { LegalLayout, LegalSection } from './LegalLayout';

export const Terms = () => {
  return (
    <LegalLayout
      title="Terms and Conditions"
      lastUpdated="Last Updated: June 13, 2026"
      testId="terms-page"
    >
      <LegalSection testId="terms-intro">
        <p>
          Welcome to Apex Athletic Mind Consulting LLC (doing business as “Apex Athletic Mind”). These Terms and Conditions (“Terms”) govern your use of our website, apexathleticmind.com, and any services, digital products, workshops, or apps (including the Apex AI Coach and The Locker Room) provided by us.
        </p>
      </LegalSection>

      <LegalSection heading="1. Acceptance of Terms" testId="terms-acceptance">
        <p>
          By accessing this website, taking our mindset quiz, or purchasing any products, you agree to these Terms. If you are under 18, a parent or legal guardian must review and agree to these Terms on your behalf.
        </p>
      </LegalSection>

      <LegalSection heading="2. Not a Medical or Mental Health Service" testId="terms-not-medical">
        <p>
          <strong>Apex Athletic Mind Consulting LLC provides mental performance coaching, not therapy.</strong>
        </p>
        <p>
          Our services are educational and developmental. We are not licensed psychologists, medical doctors, or clinical counselors. Our programs are not a substitute for professional medical advice, diagnosis, or treatment. If you are in a crisis, please call 988 (Suicide & Crisis Lifeline) or 911.
        </p>
      </LegalSection>

      <LegalSection heading="3. Intellectual Property" testId="terms-ip">
        <p>
          All content, including the Apex Six&trade; framework, The ABC Confidence Stack&trade;, and all materials in “The Locker Room” or the Apex AI Coach app, are the exclusive property of Apex Athletic Mind Consulting LLC. You may not copy, record, or redistribute our materials without our express written permission.
        </p>
      </LegalSection>

      <LegalSection heading="4. Payments and Refunds" testId="terms-payments">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Digital Products:</strong> Due to the instant delivery of digital products (like the $27 Athlete IDP), these are generally non-refundable once the assessment is accessed.
          </li>
          <li>
            <strong>Coaching Sessions:</strong> Cancellations made at least 24 hours in advance will receive a full credit or refund. Cancellations within 24 hours of a session are non-refundable.
          </li>
          <li>
            <strong>The Locker Room / AI App:</strong> Subscriptions are billed on a recurring basis and can be canceled at any time, but we do not offer pro-rated refunds for the current billing cycle.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="5. User Conduct & Accounts" testId="terms-conduct">
        <p>
          If you create an account for our digital tools, you are responsible for maintaining the confidentiality of your login. We reserve the right to terminate access if we find any violations such as sharing login info or harassment.
        </p>
      </LegalSection>

      <LegalSection heading="6. Limitation of Liability" testId="terms-liability">
        <p>
          We strive for elite results, but individual performance depends on many factors. Apex Athletic Mind Consulting LLC does not guarantee specific athletic outcomes. Our total liability is limited to the amount you paid us in the past 12 months.
        </p>
      </LegalSection>

      <LegalSection heading="7. Governing Law" testId="terms-governing-law">
        <p>
          These Terms are governed by the laws of the State of New Jersey. Any disputes will be settled in the courts of Camden County, NJ.
        </p>
      </LegalSection>

      <LegalSection heading="8. Contact Us" testId="terms-contact">
        <p>If you have any questions, please contact:</p>
        <div className="bg-white border border-black/8 rounded-xl p-5 shadow-sm mt-3">
          <p className="font-semibold text-[#1a1a1a]">Apex Athletic Mind Consulting LLC</p>
          <p className="text-[#3a3a3a]">1820 Chapel Avenue W</p>
          <p className="text-[#3a3a3a]">Suite 300-100A PMB 70263</p>
          <p className="text-[#3a3a3a]">Cherry Hill, NJ 08002</p>
          <p className="text-[#3a3a3a] mt-2">
            Email:{' '}
            <a
              href="mailto:volewis@apexathleticmind.com"
              className="text-[#004C54] font-medium hover:underline"
              data-testid="terms-contact-email"
            >
              volewis@apexathleticmind.com
            </a>
          </p>
        </div>
      </LegalSection>
    </LegalLayout>
  );
};

export default Terms;
